import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import Typography from '@material-ui/core/Typography';
import NonSwipeableDrawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

// app: assets
import CssActionSheet from './ActionSheet.scss';

function ActionSheet(props) {
  const {
    heading,
    image,
    itemRenderer,
    onClose,
    onOpen,
    subHeading,
    swipeable,
    visible,
    withCloseButton,
    heightVh,
    maxHeightVh,
  } = props;
  useStyles(CssActionSheet);
  const Drawer = swipeable ? SwipeableDrawer : NonSwipeableDrawer;
  const eventHandlers = swipeable ? { onOpen, onClose } : { onClose };
  return (
    <Drawer elevation={0} anchor="bottom" open={visible} {...eventHandlers}>
      <div
        className="action-sheet"
        style={{ height: `${heightVh}vh`, maxHeight: maxHeightVh ? `${maxHeightVh}vh` : 'inherit' }}
      >
        {heading ? (
          <div className="action-sheet__header">
            {withCloseButton ? (
              <button type="button" className="action-sheet__close" onClick={onClose}>
                Close
              </button>
            ) : null}
            <div className="action-sheet__image">{image}</div>
            <Typography variant="h2" className="action-sheet__title">
              {heading}
            </Typography>
            {subHeading ? <Typography>{subHeading}</Typography> : null}
          </div>
        ) : null}
        {!heading && withCloseButton ? (
          <div className="action-sheet__header">
            <button type="button" className="action-sheet__close" onClick={onClose}>
              Close
            </button>
          </div>
        ) : null}
        <div className="action-sheet__items">{itemRenderer()}</div>
      </div>
    </Drawer>
  );
}

ActionSheet.propTypes = {
  heading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  image: PropTypes.node,
  itemRenderer: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  subHeading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  swipeable: PropTypes.bool,
  visible: PropTypes.bool,
  withCloseButton: PropTypes.bool,
  heightVh: PropTypes.number,
  maxHeightVh: PropTypes.number,
};

ActionSheet.defaultProps = {
  heading: null,
  image: null,
  onOpen: () => {},
  onClose: () => {},
  subHeading: null,
  swipeable: true,
  visible: false,
  withCloseButton: false,
  heightVh: null,
  maxHeightVh: null,
};

export default ActionSheet;
